<template>
    <v-container fluid class="pa-2">
        <!--<v-img
           :src="ClientImage || ClientLogo"
                    width="180px"
                     ></v-img>-->

        <v-row>
            <!-- Columna esquerra (contingut) -->
            <v-col cols="12" md="8">
                <!-- Contingut principal -->
            </v-col>

            <!-- Columna dreta (botó + buscador) -->
            <v-col cols="12" md="4">
                <div class="d-flex align-center mb-4" style="gap: 8px;">
                    <!-- Buscador -->
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Busca tu campaña"
                        single-line
                        hide-details
                        class="flex-grow-1 caixa_buscador"
                    />

                    <!-- Botó selector -->
                    <v-btn
                        :icon="true"
                        @click="toggleVista"
                        style="width: 36px; height: 36px; min-width: 36px;"
                        elevation="2"
                        variant="plain"
                    >
                        <v-icon size="20">
                            {{ vista === 'cards' ? 'mdi-view-list' : 'mdi-view-grid' }}
                        </v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <!-- Loader -->
        <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
        ></v-progress-linear>

        <!-- VISTA DE TARGETES -->
        <v-row v-if="vista === 'cards' && !loading">
            <v-col
                v-for="campanya in paginatedCampanyes"
                :key="campanya.id"
                cols="12"
                sm="6"
                md="2"
                style="flex: 0 0 20%; max-width: 20%;"
            >
                <!-- amb el flex al 20% forcem a 5 columnes -->

                <v-hover v-slot="{ isHovering, props }">
                    <v-card
                        v-bind="props"
                        class="elevation-8 rounded-xl campaign-card"
                        :style="{
                          transform: isHovering ? 'scale(1.03)' : 'scale(1)',
                          transition: 'transform 0.3s ease',
                          minHeight: '480px',
                          maxWidth: '380px',
                        }"
                        @click="getServeis(campanya.desc_agrupada, campanya.idCamp)"
                    >
                        <v-img
                            :src="campanya.img || ClientImage || ClientLogo"
                            height="300px"
                            aspect-ratio="16/9"
                            cover>
                        </v-img>

                        <v-card-title
                            class="font-weight-bold d-flex align-start content-wrapper"
                            style="white-space: normal;"
                        >
                            <h3
                                class="title id"
                                style="margin: 0; white-space: normal; word-break: break-word;"
                            >
                                {{ campanya.desc_agrupada ? campanya.desc_agrupada : campanya.description }}
                            </h3>
                        </v-card-title>

                        <v-card-subtitle>
                            <p class="txt_blanc">
                                {{ campanya.name }}
                                <!-- Icona per modal credencials -->
                                {{ campanya.usr }}

                                <v-icon
                                    v-if="campanya.user && campanya.pwd"
                                    size="15"
                                    color="green"
                                    class="ml-2"
                                    @click.stop="mostrarCredencials(campanya)"
                                    style="cursor: pointer; vertical-align: middle;"
                                    title="Credencials"
                                >
                                    mdi-link
                                </v-icon>

                                <!-- Icona per enllaç Odoo -->
                                <v-icon
                                    v-if="admin"
                                    size="14"
                                    color="blue"
                                    class="ml-2"
                                    @click.stop="openExternalLink(campanya)"
                                    style="cursor: pointer; vertical-align: middle;"
                                >
                                    mdi-open-in-new
                                </v-icon>

                                <!-- Icona per obrir modal del Admin -->
                                <v-icon
                                    v-if="admin"
                                    size="14"
                                    color="purple"
                                    class="ml-2"
                                    @click.stop="obrirModal(campanya)"
                                    style="cursor: pointer; vertical-align: middle;"
                                >
                                    mdi-pencil
                                </v-icon>
                            </p>
                        </v-card-subtitle>

                        <v-card-subtitle class="data-format" style="margin-bottom: 10px;">
                            {{ formatDateRange(campanya.start_date, campanya.end_date) }}
                        </v-card-subtitle>

                        <div v-if="getEstat(campanya).estatActual == 4" class="text-end finalitzat">
                            FINALIZADA
                        </div>
                        <div v-else style="padding: 14px;"></div>

                        <!-- ESTAT DE LA CAMPANYA -->
                        <div class="card-bottom">
                            <div
                                class="linea-campanya d-flex justify-space-between align-center my-4"
                                style="background-color: white;"
                            >
                                <div
                                    v-for="(pas, index) in estats"
                                    :key="index"
                                    class="estat"
                                >
                                    <v-tooltip location="top">
                                        <template #activator="{ props }">
                                            <v-icon
                                                v-bind="props"
                                                :color="getColorEstat(campanya, index)"
                                                size="26"
                                                class="icona-pas"> {{ pas.icon }}</v-icon>

                                        </template>
                                        <span>{{ pas.nom }}</span>
                                    </v-tooltip>

                                    <div
                                        v-if="index < estats.length - 1"
                                        class="linia"
                                        :class="{ activa: index < estatActual }"
                                    ></div>
                                </div>
                            </div>


                        </div>
                    </v-card>
                </v-hover>
            </v-col>

            <v-row class="mt-4" justify="center">
                <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(filteredCampanyes.length / cardsPerPage)"
                    color="primary"
                ></v-pagination>
            </v-row>
        </v-row>

        <!-- VISTA DE TAULA -->
        <v-data-table
            v-else-if="vista === 'table' && !loading"
            :headers="headers"
            :items="filteredCampanyes"
            :items-per-page="25"
            class="elevation-1 bg-white text-black"
            thead-class="bg-primary text-white"
        >
            <template #item.imatge="{ item }">
                <v-img
                    :src="getCardImage(item)"
                    max-height="40"
                    max-width="100"
                    cover
                    class="rounded"
                    @error="markImageAsBroken(item)"
                />
            </template>

            <template #item.name="{ item }">
                <div class="d-flex align-center">
                    <!--
                    <router-link
                      :to="buildCampInfoPath(item.idCamp)"
                      class="titol_llista"
                    >
                      {{ item.idCamp }}
                    </router-link>
                    -->

                    <!-- Icona per modal credencials -->
                </div>
            </template>

            <template #item.description="{ item }">
                <router-link
                    :to="buildCampInfoPath(item.idCamp)"
                    class="titol_llista"
                >
                    {{ item.desc_agrupada ? item.desc_agrupada : item.description }}
                </router-link>

                <v-icon
                    v-if="item.usr && item.pwd"
                    size="15"
                    color="green"
                    class="ml-2"
                    @click.stop="mostrarCredencials(item)"
                    style="cursor: pointer; vertical-align: middle;"
                    title="Credencials"
                >
                    mdi-link
                </v-icon>

                <!-- Icona per enllaç Odoo -->
                <v-icon
                    v-if="admin"
                    size="16"
                    color="blue"
                    class="ml-2"
                    @click.stop="openExternalLink(item)"
                    style="cursor: pointer;"
                >
                    mdi-open-in-new
                </v-icon>

                <!-- Icona per obrir modal del Admin -->
                <v-icon
                    v-if="admin"
                    size="14"
                    color="purple"
                    class="ml-2"
                    @click.stop="obrirModal(item)"
                    style="cursor: pointer; vertical-align: middle;"
                >
                    mdi-pencil
                </v-icon>
            </template>

            <template #item.start_date="{ item }">
                {{ formatDate(item.start_date) }}
            </template>

            <template #item.end_date="{ item }">
                {{ formatDate(item.end_date) }}
            </template>
        </v-data-table>

        <!-- MODAL ADMINISTRACIO -->
        <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            width="75%"
            max-width="75vw"
            persistent
        >
            <v-card
                class="pa-4 elevation-10 rounded-xl"
                style="height: 75vh; background-color: var(--color-background); backdrop-filter: blur(8px);"
            >
                <v-card-title class="text-h6 font-weight-bold">
                    Administrador
                </v-card-title>

                <v-card-text>
                    <p>{{ selectedCampanya?.name }} / {{ selectedCampanya.description }}</p>

                    <v-text-field
                        :model-value="campaignUrl"
                        label="URL de la campaña"
                        density="compact"
                        variant="outlined"
                        class="mt-4"
                        readonly
                        append-inner-icon="mdi-content-copy"
                        @click:append-inner="copiarCampaignUrl"
                    />

                    <v-file-input
                        label="Imágen de la campaña"
                        v-model="imatge"
                        accept="image/*"
                        variant="outlined"
                        prepend-icon="mdi-camera"
                        class="mt-4"
                    />

                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn variant="text" @click="dialog = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="enviarCredenciales">Guardar cambios</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL CREDENCIALS CAMPANYA -->
        <v-dialog
            v-model="credencialsDialog"
            transition="dialog-bottom-transition"
            width="30%"
            max-width="75vw"
            persistent
        >
            <v-card
                class="pa-4 elevation-10 rounded-xl"
                style="height: 75vh; background-color: rgba(255,255,255,0.9); backdrop-filter: blur(8px);"
            >
                <v-card-title class="text-h6 font-weight-bold">
                    Credenciales de la campaña
                </v-card-title>

                <v-card-text>
                    <h2>DEMO Falta crear la pagina</h2>
                    <p><strong>Enlace:</strong> <a :href="infoCredencials?.url_name"
                                                   target="_blank">{{ infoCredencials?.url_name }}</a></p>
                    <p><strong>Usuario:</strong> {{ infoCredencials?.usr }}</p>
                    <p><strong>Contraseña:</strong> {{ infoCredencials?.pwd }}</p>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn variant="text" @click="credencialsDialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script setup>
import useCampanyes from '@/composables/CampaignList/useCampaignList.js'

const {
    search,
    vista,
    loading,
    headers,
    admin,
    filteredCampanyes,
    paginatedCampanyes,
    dialog,
    selectedCampanya,
    usuario,
    contrasena,
    imatge,
    campaignUrl,
    copiarCampaignUrl,
    credencialsDialog,
    infoCredencials,
    botigaFiltre,
    formatDate,
    formatDateRange,
    openExternalLink,
    toggleVista,
    obrirModal,
    enviarCredenciales,
    mostrarCredencials,
    estats,
    estatActual,
    getEstat,
    getColorEstat,
    getServeis,
    ClientLogo,
    ClientImage,
    cardsPerPage,
    currentPage,
    buildCampInfoPath,
    getCardImage,
    markImageAsBroken,
} = useCampanyes()
</script>

<style scoped>
.titol_llista {
    color: #1c1c1c;
    font-size: 15px;
    text-decoration: none;
}

.linea-campanya {
    position: relative;
    width: 100%;
}

.estat {
    flex: 1;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.icona-pas {
    z-index: 2;
    position: relative;
    background: white;
    border-radius: 50%;
    padding: 4px;
}

.etiqueta {
    margin-top: 4px;
    font-size: 12px;
    text-align: center;
    max-width: 80px;
    word-break: break-word;
}

.linia {
    position: absolute;
    top: 14px;
    right: -50%;
    height: 0;
    width: 100%;
    border-top: 2px dotted #ccc;
    z-index: 1;
}

.linia.activa {
    border-top: 2px dotted var(--color-primary);
}

.card-bottom {
    background: white;
    color: black;
    padding: 1px;
    border-radius: 0 0 12px 12px;
}

.data-format {
    color: var(--color-text);
    font-size: 16px;
    font-weight: 700;
    font-style: italic;
}

.finalitzat {
    color: #24a20b;
    font-size: 16px;
    font-weight: 600;
    padding-right: 10px;
    padding-bottom: 3px;
}

.caixa_buscador {
    background-color: black !important;
    color: white !important;
    border-radius: 12px;
    border: 3px solid var(--color-primary);
    padding: 0 !important;
    z-index: 10;
}

/*
.caixa_buscador .v-field__overlay {
  background-color: white !important;
  opacity: 1 !important;
}
*/
</style>
